      $(document).ready(function(){
      $(".block__test-drive-tab-logo-logo-slider").slick({
        draggable: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 0,
        speed: 5000,
        pauseOnHover: false,
        cssEase: 'linear',
        variableWidth: true
      });
      
      // Auto cycle header content every 1.5 seconds
      var $header = $('.block__test-drive-tab-logo-box-header');
      if ($header.length > 0) {
        var titles = JSON.parse($header.attr('data-cycle-titles') || '[]').filter(Boolean);
        var contents = JSON.parse($header.attr('data-cycle-contents') || '[]').filter(Boolean);
        
        if (titles.length > 0 && contents.length > 0) {
          var currentIndex = 0;
          
          setInterval(function() {
            var $h4 = $header.find('h4');
            var $p = $header.find('p');
            
            $h4.fadeOut(300, function() {
              $(this).text(titles[currentIndex]).fadeIn(300);
            });
            
            $p.fadeOut(300, function() {
              $(this).text(contents[currentIndex]).fadeIn(300);
            });
            
            currentIndex = (currentIndex + 1) % Math.min(titles.length, contents.length);
          }, 1500);
        }
      }
  })